export default __webpack_public_path__ + "static/Vol 3 - TA 10B - AIA (with appendices)-aa836768f93a173d5e9ab268a742e5ba.pdf";